import axios from '@axios'

const route = 'system/config/printers'

export default {
  namespaced: true,
  actions: {
    list() {
      return axios.get(route)
    },
    listPrinters() {
      return axios.get(route)
    },
    create(_, payload) {
      return axios.post(route, payload)
    },
    update(_, payload) {
      return axios.put(`${route}/${payload.id}`, payload)
    },
    delete(_, id) {
      return axios.delete(`${route}/${id}`)
    },
  },
}
